var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.error
      ? _c("div", { staticClass: "text-center my-5" }, [
          _c("p", { staticClass: "text-secondary" }, [
            _vm._v(_vm._s(_vm.$t("common.error_fetch_data"))),
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "text-primary link",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.fetchData.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(_vm._s(_vm.$t("common.rfrsh_page")) + " "),
              _c("i", { staticClass: "icon fa fa-refresh" }),
            ]
          ),
        ])
      : _c(
          "div",
          [
            _c("StatCards", { attrs: { cards: _vm.cards } }),
            _vm._v(" "),
            _c(
              "b-container",
              { staticClass: "my-5", attrs: { fluid: "" } },
              [
                _vm.chartData
                  ? _c("HorizontalBarChart", {
                      attrs: { chartData: _vm.chartData, options: _vm.options },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("b-table", {
              attrs: {
                striped: "",
                hover: "",
                bordered: "",
                items: _vm.items,
                fields: _vm.fields,
                "sort-by": "vendeur",
                busy: !_vm.items,
              },
              scopedSlots: _vm._u([
                {
                  key: "cell(repartition)",
                  fn: function (data) {
                    return [
                      _c("RepartitionBar", {
                        attrs: {
                          total: data.value.total,
                          facture: data.value.facture,
                          paye: data.value.paye,
                          reverse: data.value.reverse,
                          non_facture: data.value.non_facture,
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "table-busy",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "text-center greenFont my-2" },
                        [
                          _c("b-spinner", { staticClass: "align-middle" }),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("common.chrg_data"))),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }